import { Controller } from 'stimulus'
import PdfViewer from '../lib/pdf-viewer'

export default class extends Controller {
  static values = { file: String, page: Number }

  connect() {
    new PdfViewer(this.element, this.fileValue, this.pageValue)
  }
}
